import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

export type Inputs = "tipoBusqueda" | "idUser" | "codigo";
export type Buttons = "buscar" | "descargar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "Tipo de Búsqueda",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Empleado",
        data: [{ value: "CODIGO", label: "Por Código" }]
      }
    },
    {
      name: "idUser",
      label: "Empleado",
      bts: { mCol: 4 },
      component: IUserSelectorBuilder,
      props: {
        hidden: values => !!values.tipoBusqueda
      }
    },
    {
      name: "codigo",
      label: "Código",
      bts: { mCol: 3 },
      component: ITextBuilder,
      props: {
        uppercase: true,
        maxlength: 20,
        hidden: values => values.tipoBusqueda !== "CODIGO"
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    },
    {
      name: "descargar",
      label: "Descargar",
      isSubmit: false,
      bts: { mCol: 3 }
    }
  ],
  validations: {
    idUser: {
      requiredIfUsuario: {
        validator: (value, formValue) => !formValue.tipoBusqueda && !value,
        message: () => "Campo obligatorio"
      }
    },
    codigo: {
      requiredIfCodigo: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "CODIGO" && !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [["tipoBusqueda", "idUser", "codigo", "buscar", "descargar"]]
};
